import * as Yup from 'yup';
import { validateField, ValidationType } from './formValidation';
import type { ChangePasswordInterface, MyAccountInterface } from 'types';

export const myAccountDefaultValues: Partial<MyAccountInterface> = {
    firstname: '',
    lastname: '',
    email: '',
    language_setting: 'EN',
};

export const myAccountValidationSchema = Yup.object({
    email: validateField(ValidationType.EMAIL),
    firstname: validateField(ValidationType.STRING),
    lastname: validateField(ValidationType.STRING),
    language_setting: validateField(ValidationType.STRING),
});

export const changePasswordDefaultValues: ChangePasswordInterface = {
    currentPassword: '',
    newPassword: '',
    repeatPassword: '',
};

export const changePasswordValidationSchema = Yup.object({
    currentPassword: validateField(ValidationType.STRING),
    newPassword: validateField(ValidationType.PASSWORD),
    repeatPassword: validateField(ValidationType.RETYPED_PASSWORD),
});
